var headerHeight = document.querySelector('header').offsetHeight;
var anchorElement = document.querySelector('.block_anchor');
var anchorElementInner = document.querySelector('.block_anchor .inner');
var anchorHeight = anchorElement.offsetHeight;
var anchorElementTop = getOffset(anchorElement).top;

anchorElement.style.height = anchorHeight + 'px';

document
    .querySelectorAll('.block_anchor .anchor')
    .forEach(trigger => {
        trigger.onclick = function (e) {
            e.preventDefault();
            let hash = this.getAttribute('href');
            let target = document.querySelector(hash);
            let headerOffset = anchorHeight + headerHeight;
            let elementPosition = target.offsetTop;
            let offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        };
    });

function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY
    };
}

function fixedAnchorElement() {
    if ((window.pageYOffset + 65) > anchorElementTop) {
        anchorElementInner.classList.add('fixed');
    } else if (window.pageYOffset < (anchorElementTop - headerHeight)) {
        anchorElementInner.classList.remove('fixed');
    }
}

window.addEventListener('scroll', fixedAnchorElement);
